/* eslint-disable linebreak-style */
/* eslint-disable quotes */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import Input from "../common/Input";
import { calculateDisplayedErrors } from "../common/Helpers";

const EYE_PATH = [
  "M12 4c7 0 11 8 11 8s-4 8-11 8S1 12 1 12s4-8 11-8Zm0 2C7.6 6 4.4 10.3 3.2 12",
  "4.4 13.7 7.6 18 12 18s7.6-4.3 8.8-6C19.6 10.3 16.4 6 12 6Zm0 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
].join(" ");

const EYE_OFF_PATH = [
  "M3.3 2 22 20.7l-1.3 1.3-3.1-3.1A11.8 11.8 0 0 1 12 20C5 20 1 12 1 12a20.2 20.2 0 0 1 4.3-5.6L2 3.3 3.3 2Zm4.9 7.6",
  "A4 4 0 0 0 14.4 16l-1.6-1.6a2 2 0 0 1-3.2-3.2L8.2 9.6ZM12 4c7 0 11 8 11 8a19.7 19.7 0 0 1-3.2 4.6l-2.9-2.9A5 5 0 0 0 10.3 7L7.9 4.7A11.7 11.7 0 0 1 12 4Zm0 3a5 5 0 0 1 5 5v.2l-5.2-5.2H12Z",
].join(" ");

function LoginForm({
  username,
  password,
  touched,
  errors,
  onBlur,
  onChange,
  onSubmit,
  onCancel,
  disabled,
  status,
  ssoButton,
}) {
  const { t: tr } = useTranslation();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const err = calculateDisplayedErrors(errors, touched, status);
  return (
    <div className="quiz-text manage-login-form">
      <h2><strong>{tr("auth:loginHeading")}</strong></h2>
      <form id="client-form" className="manage-login-form__form" onSubmit={onSubmit}>

        <div className="form-row">
          <div className="col-12">
            <Input
              label={tr("auth:userEmail")}
              type="email"
              inputMode="email"
              autoComplete="username"
              onBlur={onBlur}
              onChange={onChange}
              name="username"
              value={username}
              error={err.username}
              placeholder={tr("auth:user")}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="col-12">
            <Input
              className="manage-login-form__password-field"
              label={tr("common:password")}
              type={isPasswordVisible ? "text" : "password"}
              autoComplete="current-password"
              onBlur={onBlur}
              onChange={onChange}
              name="password"
              value={password}
              error={err.password}
              placeholder={tr("common:password")}
              append={(
                <button
                  type="button"
                  className="btn manage-login-form__password-toggle"
                  onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                  aria-label={tr(isPasswordVisible ? "auth:hidePassword" : "auth:showPassword")}
                  aria-pressed={isPasswordVisible}
                >
                  <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
                    <path d={isPasswordVisible ? EYE_OFF_PATH : EYE_PATH} />
                  </svg>
                </button>
              )}
            />
          </div>
        </div>

        <div className="manage-login-form__help-links">
          <div>
            <Link to="/manage/password-reset">{tr("auth:forgotPassword")}</Link>
          </div>
          <div>
            <Link to="/account/signup">{tr("auth:firstLogin")}</Link>
          </div>
        </div>

        <div className="manage-login-form__actions">
          <div>
            <button type="submit" className="btn manage-button manage-red-button btn-block" disabled={disabled}>{tr(disabled ? "auth:loggingIn" : "auth:login")}</button>
          </div>
          <div>
            <button type="button" className="btn manage-login-form__back-button btn-block" onClick={onCancel} disabled={disabled}>{tr("auth:backHome")}</button>
          </div>
        </div>
      </form>

      {ssoButton && (
        <div className="manage-login-form__sso">
          <div className="mt-3 mb-2"><strong>{tr("common:or")}</strong></div>
          {ssoButton}
        </div>
      )}
    </div>
  );
}

LoginForm.propTypes = {
  username: PropTypes.string,
  password: PropTypes.string,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  ssoButton: PropTypes.node,
};

LoginForm.defaultProps = {
  username: "",
  password: "",
  disabled: false,
  ssoButton: null,
};

export default LoginForm;
